import { BaseResponseMapper } from '@/data/persistences/mappers/BaseMapper'
import { AxiosResponse } from 'axios'
import { Pagination } from '@/domain/entities/Pagination'
import {
  WhiteListSeller,
  WhiteSeller,
  WhiteSellerCorporateClient,
  WhiteSellerPhone,
  WhiteSellerPickupPoint,
  WhiteSellerBoundPickupPoints,
} from '@/domain/entities/WhiteSeller'
import { Utils } from '@/app/infrastructures/misc'
import { Report } from '@/domain/entities/Main'

export class WhiteSellerMapper extends BaseResponseMapper {
  public convertWhiteListSellerFromApi(result: AxiosResponse): WhiteListSeller {
    const {
      data: { data, pagination },
    } = result

    return new WhiteListSeller(
      new Pagination(pagination.page, pagination.limit, pagination.total_data),
      data.map(
        (item: Record<string, any>) =>
          new WhiteSeller(
            item.id,
            item.name,
            item.partner_pos,
            item.partner_code,
            '',
            item.role,
            item.status,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            item.courier_id,
            item.courier_name,
            item.assign_type,
            undefined,
            item.client_name,
            item.client,
            item.address,
            item.address_count
          )
      )
    )
  }

  public convertDetailWhiteSellerFromApi(result: AxiosResponse): WhiteSeller {
    const {
      data: { data },
    } = result

    return new WhiteSeller(
      data.id,
      data.name,
      data.partner_pos,
      data.partner_code,
      '',
      data.role,
      data.status,
      data.partner_id,
      data.cod_handling,
      data.created_at,
      data.created_by,
      data.updated_at,
      data.updated_by,
      data.courier_id,
      data.courier_name,
      data.assign_type,
      data.client_id !== undefined && data.client_id !== null ? Number(data.client_id) : undefined,
      data.client_name
    )
  }

  public convertExportWhiteSellerFromApi(result: AxiosResponse): string {
    const {
      data: { data },
    } = result

    return data.url
  }

  public convertExportWhiteListFromApi(result: AxiosResponse): Report[] {
    const {
      data: { data },
    } = result

    return data?.map(
      (item: Record<string, any>) =>
        new Report(
          Utils.toInstance(new Map(), JSON.stringify(item), 'camelCase') as any
        )
    )
  }

  public convertExportWhiteListFromApiWS(result: AxiosResponse): Report {
    const { data: {bulk_download} } = result

    return new Report({
      createdAt: bulk_download.created_at,
      id: bulk_download.id,
      status: bulk_download.status,
      type: bulk_download.type,
    })
  }

  public convertWhitelistSellerPhoneFromApi(result: AxiosResponse): WhiteSellerPhone {
    const { data: { data } } = result;

    return new WhiteSellerPhone(data.phone);
  }

  public convertCorporateClientsFromApi(
    result: AxiosResponse
  ): WhiteSellerCorporateClient[] {
    const {
      data: { data },
    } = result

    // Client identifier is never derived from code/name (A-FE-02);
    // rows without a numeric client_id cannot be selected safely.
    return (data || [])
      .filter((item: Record<string, any>) => Number(item.client_id) > 0)
      .map(
        (item: Record<string, any>) =>
          new WhiteSellerCorporateClient(
            Number(item.client_id),
            item.client_code,
            item.client_name
          )
      )
  }

  public convertCorporatePickupPointsFromApi(
    result: AxiosResponse
  ): WhiteSellerPickupPoint[] {
    const {
      data: { data },
    } = result

    return (data || []).map(
      (item: Record<string, any>) =>
        new WhiteSellerPickupPoint(
          Number(item.pca_id),
          item.pca_name,
          item.pca_pic_name,
          item.pca_phone_number,
          item.pca_address,
          item.pca_latlon
        )
    )
  }

  public convertBoundPickupPointsFromApi(
    result: AxiosResponse
  ): WhiteSellerBoundPickupPoints {
    const {
      data: { data, pagination },
    } = result

    const points = (data || []).map(
      (item: Record<string, any>) =>
        new WhiteSellerPickupPoint(
          Number(item.pca_id),
          item.pca_name,
          item.pca_pic_name,
          item.pca_phone_number || '',
          item.pca_address || '',
          item.pca_latlon || ''
        )
    )

    const pag = pagination
      ? new Pagination(pagination.page, pagination.limit, pagination.total_data)
      : new Pagination(1, 50, points.length)

    return new WhiteSellerBoundPickupPoints(points, pag)
  }
}
